module.exports = __webpack_public_path__ + "img/ex.d05451dd.jpeg";